var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondFirstLedgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 129,
    viewBox: "0 0 130 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First Ledger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_14980)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1117,
    cy: 24.5193,
    rx: 25.1117,
    ry: 24.5193,
    transform: "matrix(0.985544 0.169418 -0.177977 0.984035 44.2266 36)",
    fill: "#7600FC",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_14980)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1117,
    cy: 24.5193,
    rx: 25.1117,
    ry: 24.5193,
    transform: "matrix(0.985544 0.169418 -0.177977 0.984035 44.2266 36)",
    fill: "#7600FC",
    fillOpacity: 0.82
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.0938 45.5586L83.9184 51.2012L78.1305 83.2023L45.3059 77.5597L51.0938 45.5586ZM66.5441 67.0719C65.1232 66.8277 63.8324 66.6513 62.5664 66.3621C62.0931 66.2447 61.6725 65.9789 61.3693 65.6058C59.8223 63.5386 58.3453 61.4293 56.8299 59.3351C56.6182 59.043 56.3786 58.7699 56.0901 58.4103L53.6545 71.8767L72.3092 75.0835L75.5987 56.8957L61.7393 54.5132C62.0565 54.9839 62.2629 55.3055 62.4828 55.6142C63.9436 57.6535 65.4221 59.6807 66.855 61.7391C67.1236 62.1027 67.262 62.5424 67.249 62.9903C67.0918 64.2898 66.8098 65.5786 66.5402 67.0691L66.5441 67.0719Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14980",
    x: 0.176563,
    y: 0.578907,
    width: 128.87,
    height: 127.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14980",
    x: 0.176563,
    y: 0.578907,
    width: 128.87,
    height: 127.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14980"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondFirstLedgerIcon);
export default __webpack_public_path__ + "static/media/SecondFirstLedgerIcon.e502fbc729047db140b2feac2e6edc99.svg";
export { ForwardRef as ReactComponent };